import styled from "@emotion/styled";
import { TextField } from "@mui/material";

export const InputStyled = styled(TextField, {
  shouldForwardProp: prop => prop !== "addStyles",
})`
  .MuiInputBase-root {
    border-radius: 50px;
    color: ${props => props.theme.colors.white};
    font-weight: 500;
    transition: 0.3s;
    font-size: 14px;

    @media (min-width: ${props => props.theme.screenSizes.mdMax}) {
      font-size: 18px;
    }

    .MuiInputBase-input {
      box-sizing: border-box;
      height: 70px;
      padding-left: ${p => p.theme.space[7]}px;
      padding-right: ${p => p.theme.space[7]}px;

      @media (max-width: ${props => props.theme.screenSizes.mdMax}) {
        height: 44px;
        padding-left: 20px;
        padding-right: 20px;
      }
    }

    .MuiOutlinedInput-notchedOutline {
      border-color: ${props => props.theme.colors.secondary.gray};
    }

    &:hover fieldset {
      border-color: ${props => props.theme.colors.secondary.minor};
    }

    &.Mui-focused fieldset {
      border-color: transparent;
    }

    &.Mui-focused {
      background-color: ${props => props.theme.colors.white};
      color: ${props => props.theme.colors.secondary.title};
    }
  }

  &.grey .MuiInputBase-root {
    background-color: ${props => props.theme.colors.background};
    border-color: transparent;
    color: ${props => props.theme.colors.secondary.main};

    .MuiInputBase-input {
      &::placeholder {
        color: ${props => props.theme.colors.secondary.minor};
        opacity: 0.64;
      }
    }

    &:hover {
      background-color: ${props => props.theme.colors.secondary.stroke};

      fieldset {
        border-color: ${props => props.theme.colors.secondary.stroke};
      }
    }

    .MuiOutlinedInput-notchedOutline {
      border-color: ${props => props.theme.colors.background};
    }

    &.Mui-focused fieldset {
      border-color: ${props => props.theme.colors.secondary.stroke};
    }

    &.Mui-focused {
      background-color: ${props => props.theme.colors.background};
      color: ${props => props.theme.colors.black};
    }
  }

  ${props => props.addStyles}
`;
